// extracted by mini-css-extract-plugin
module.exports = {"table":"antragsuebersicht_table__y9JJA"};